import Rollbar from "rollbar";
import { env } from "@/lib/env";

export const rollbar = new Rollbar({
  accessToken: env.VITE_ROLLBAR_TOKEN || "",
  environment: env.VITE_APP_ENV,
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: !!env.VITE_ROLLBAR_TOKEN && env.VITE_APP_ENV !== "development",
});
